// extracted by mini-css-extract-plugin
module.exports = {"container":"Table_container__985vz","scroll":"Table_scroll__c0SS4","table":"Table_table__Dsg2F","pagination":"Table_pagination__VKyB8","paginationBtn":"Table_paginationBtn__MjutC"};